import script from "./WorkersCompTCPA.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkersCompTCPA.vue?vue&type=script&setup=true&lang=js"

import "./WorkersCompTCPA.vue?vue&type=style&index=0&id=56a6da06&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a6da06"]])

export default __exports__